import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18 3.422h-1c0-1.076-.9-1.955-2-1.955H9c-1.1 0-2 .88-2 1.955H6c-1.7 0-3 1.27-3 2.933v12.708c0 1.662 1.3 2.933 3 2.933h12c1.7 0 3-1.27 3-2.933V6.355c0-1.662-1.3-2.933-3-2.933m-9 0h6v1.955H9zm10 15.702c0 .55-.4.917-1 .917H6c-.6 0-1-.367-1-.917V6.294c0-.55.4-.917 1-.917h1c0 1.008.9 1.833 2 1.833h6c1.1 0 2-.825 2-1.833h1c.6 0 1 .367 1 .916zm-3-8.86H8c-.6 0-1 .392-1 .979 0 .586.4.977 1 .977h8c.6 0 1-.391 1-.978 0-.586-.4-.977-1-.977Zm0 3.911H8c-.6 0-1 .391-1 .978 0 .586.4.977 1 .977h8c.6 0 1-.39 1-.977s-.4-.978-1-.978"
    }, null, -1)
  ]))]))
}
export default { render: render }